import React, { useState } from "react";
import { Modal, Box, Backdrop, Fade, Typography } from "@mui/material";
import { initMercadoPago, CardPayment } from "@mercadopago/sdk-react";
import { makePayment } from "../api/dashboard";
import { useAuth } from "../context/AuthContext";

// ✅ Inicialización correcta de MercadoPago
initMercadoPago("APP_USR-fe5deaca-c35c-424c-85ea-fd22764bd5aa", {
  locale: "es-AR",
});

const SubscriptionModal = ({ openModal, setOpenModal, amount }) => {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  // 🔄 Configuración del Brick
  const initialization = {
    amount: amount.toString(),
  };

  // ✅ Acción post pago exitoso
  const onSuccess = () => {
    console.log("✅ Recarga aplicada con éxito");
    setOpenModal(false);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  // 📝 Manejo del envío del formulario
  const onSubmit = async (event) => {
    setLoading(true);
    console.log("🔥 Evento recibido en el Submit:", event);

    try {
      const payload = {
        propertyId: user.propertyId,
        transaction_amount: parseFloat(amount),
        token: event.token,
        installments: 1,
        payment_method_id: event.payment_method_id,
        payer: {
          email: event.payer.email,
          identification: {
            type: event.payer.identification.type,
            number: event.payer.identification.number,
          },
        },
      };

      console.log("🔄 Payload enviado al backend:", payload);

      const response = await makePayment(payload);
      console.log("🧾 Respuesta del backend:", response);

      if (response.status === 200) {
        onSuccess();
      } else {
        alert(response.message || "No se pudo completar el pago.");
      }
    } catch (error) {
      console.error("❌ Error al procesar el pago:", error.message);
      alert("No se pudo procesar el pago. Intenta más tarde.");
    } finally {
      setLoading(false);
    }
  };

  const onReady = () => {
    console.log("✅ Brick cargado correctamente");
  };

  const onError = (error) => {
    console.error("❌ Error en el Brick:", error);
  };

  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={openModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "110%", sm: "80%", md: "60%", lg: "50%", xl: "40%" },
            maxWidth: "600px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            overflow: "hidden",
          }}
        >
          <Typography variant="h6" mb={2} align="center">
            Ingresa los datos de tu tarjeta para pagar tus facturas
          </Typography>

          <CardPayment
            initialization={initialization}
            onSubmit={onSubmit}
            onReady={onReady}
            onError={onError}
          />
        </Box>
      </Fade>
    </Modal>
  );
};

export default SubscriptionModal;
